import {CLIENTS} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(CLIENTS)
